import React from 'react';
import { Card, Accordion } from 'react-bootstrap';

export default function Step11AccessoriesPleated({
 ContextAwareToggle,
  t,
  pageLanguage,
  isTabletOrMobile,
  requiredStep,
  stepSelectedLabel,
  liningPrice,
  stepAccessoriesList,
  GetPrice,
  NumberToPersianWord,
  tiebackDraperyQty,
  setTiebackDrapery,
  tiebackSheerQty,
  setTiebackSheer,
  NextStep,
  handCurtainPricDrapery,
  step5,
  step3,
}) {


  return (
   <Card>
   <Card.Header>
     <ContextAwareToggle
       eventKey="9"
       stepNum={step5 === "Full" && step3 === "false" ? t("7") : t("8")}
       stepTitle={t("grommet_step9")}
       stepTitle2={t("(Optional)")}
       stepRef="9"
       type="1"
       required={requiredStep["9"]}
       stepSelected={stepSelectedLabel["9"] === undefined ? "" : stepSelectedLabel["9"]}
     />
   </Card.Header>
   <Accordion.Collapse eventKey="9">
     <Card.Body>
       <div className="card_body card_body_Accessories">
         <div className="Accessories_container">
           <ul className="Accessories_List">
             <li className="Accessories_List_item">
               <div className="Accessories_List_item_image">
                 <img
                   src={require("../../Images/drapery/grommet/MatchingTieback.jpg")}
                   className="img-fluid"
                   alt=""
                 />
               </div>
               <div className="Accessories_List_item_desc">
                 <h1 
                   style={{textAlign: pageLanguage === 'fa' ? 'right' : 'left'}}
                 className="Accessories_List_item_title Accessories_List_title_new">
                   {t("Matching Drapery Tieback")}
                 </h1>
                 <h2 className="Accessories_List_item_price">
                   {handCurtainPricDrapery !== undefined && handCurtainPricDrapery !== 0
                     ? GetPrice(handCurtainPricDrapery, pageLanguage, t("TOMANS"), isTabletOrMobile)
                     : t("Surcharge Applies")}
                 </h2>
                 <div className="Accessories_List_item_colors"></div>
               </div>
               <div className="Accessories_List_item_qty">
                 <div className="qty_numbers">
                   <button
                     type="text"
                     className="qty_minus"
                     onClick={() =>
                       setTiebackDrapery({
                         isPlus: false,
                         HandCurtainId: 2401,
                         HandCurtainNum: undefined,
                       })
                     }
                   >
                     <img
                       src={require("../../Images/public/minus.svg").default}
                       alt=""
                       className="qty_math_icon"
                     />
                   </button>
                   <input
                     type="text"
                     className="qty_num"
                     name='qty_num_1'
                     value={
                       pageLanguage === "fa"
                         ? NumberToPersianWord.convertEnToPe(`${tiebackDraperyQty}`)
                         : tiebackDraperyQty
                     }
                     onChange={(e) => {}}
                     readOnly
                   />
                   <button
                     type="text"
                     className="qty_plus"
                     onClick={() =>
                       setTiebackDrapery({
                         isPlus: true,
                         HandCurtainId: 2401,
                         HandCurtainNum: undefined,
                       })
                     }
                   >
                     <img
                       src={require("../../Images/public/plus.svg").default}
                       alt=""
                       className="qty_math_icon"
                     />
                   </button>
                 </div>
               </div>
             </li>
           
             {stepAccessoriesList}
           </ul>
         </div>
       </div>
       <NextStep currentStep="9" eventKey="10">
         {t("NEXT STEP")}
       </NextStep>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
